import axios, { type AxiosResponse } from 'axios';

export type PayloadType = {
  apiUrl?: string;
  path: string;
  body?: object;
};

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8',
};

export const axiosPost = async (payload: PayloadType): Promise<AxiosResponse> => {
  const { apiUrl, path, body } = payload;
  const url: string = apiUrl ? apiUrl : process.env.REACT_API_ASSET_API_URL!;

  const options = {
    method: 'POST',
    url: url + path,
    headers,
    data: body,
    // withCredentials: true,
  };
  const re = await axios(options);
  return re;
};

export const axiosGet = async (payload: PayloadType): Promise<AxiosResponse> => {
  const { apiUrl, path } = payload;
  const url: string = apiUrl ? apiUrl : process.env.REACT_APP_ASSET_API_URL!;
  // const authToken = checkAuth(apiUrl);

  // if (authToken) {
  //   headers.auth_token = authToken;
  // } else {
  //   if (headers?.auth_token) {
  //     delete headers.auth_token;
  //   }
  // }
  const options = {
    method: 'GET',
    url: url + path,
    headers,
  };
  const re = await axios(options);
  return re;
};

export const axiosPut = async (payload: PayloadType): Promise<AxiosResponse> => {
  const { apiUrl, path, body } = payload;
  const url: string = apiUrl ? apiUrl : process.env.REACT_APP_ASSET_API_URL!;
  // const authToken = checkAuth(apiUrl);

  // if (authToken) {
  //   headers.auth_token = authToken;
  // }

  const options = {
    method: 'PUT',
    url: url + path,
    headers,
    data: body,
  };
  const re = await axios(options);
  return re;
};

export const axiosPatch = async (payload: PayloadType): Promise<AxiosResponse> => {
  const { apiUrl, path, body } = payload;
  const url: string = apiUrl ? apiUrl : process.env.REACT_APP_ASSET_API_URL!;

  const options = {
    method: 'patch',
    url: url + path,
    headers,
    data: body,
  };
  console.log(options);
  const re = await axios(options);
  return re;
};

export const axiosDelete = async (payload: PayloadType): Promise<AxiosResponse> => {
  const { apiUrl, path, body } = payload;
  const url: string = apiUrl ? apiUrl : process.env.REACT_APP_ASSET_API_URL!;
  const options = {
    method: 'DELETE',
    url: url + path,
    headers,
    data: body,
  };
  console.log(options);
  const re = await axios(options);
  return re;
};
